<template>
  <div class="container">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";

export default {
  name: "Layout",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
.header-container .router-link-active {
  color: #f08300 !important;
}

.w {
  width: 1200px;
  margin: 0 auto;
}

.m-title {
  margin-bottom: 72px;
  h2 {
    font-size: 40px;
    color: #2f393f;
    line-height: 55px;
    text-align: center;
  }
  p {
    font-size: 28px;
    font-weight: 300;
    line-height: 40px;
    color: #818181;
    text-align: center;
    padding: 16px 0;
    position: relative;
    text-transform: uppercase;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      width: 32px;
      height: 2px;
      background: #f08300;
    }
  }
}
</style>
